import React from "react";
import cx from "classnames";

export const BadgeCell = ({ value, outline = false, color = "info", className, ...props }) => {
  const classes = cx("badge", `badge-${color}`, { "badge-outline": outline }, className);

  return value ? (
    <span className={classes} {...props}>
      {value}
    </span>
  ) : null;
};
